import React, { useState } from 'react';
import { link, platform, validation } from '../../constants/appConstants';
import { useForm } from 'react-hook-form';
import ThemeInput from '../../components/inputs/ThemeInput';
import { useNavigate } from 'react-router-dom';
import ThemeButton from '../../components/buttons/ThemeButton';
import { signinSchema } from '../../schemas/authSchema';
import { yupResolver } from '@hookform/resolvers/yup';
import { setRefreshTokenLocalStorage, setTokenLocalStorage } from '../../utils/helper';
import { errorMsg, successMsg } from '../../constants/msgs';
import { useLazyGetMyProfileQuery, useSigninMutation } from '../../store/apis/authApi';
import { useDispatch } from 'react-redux';
import { setAuthUser } from '../../store/slices/authSlice';

const LoginPage = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onChange', resolver: yupResolver(signinSchema) });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [signin, { isLoading }] = useSigninMutation();
  const [fetchProfile] = useLazyGetMyProfileQuery();

  const onSubmit = async (formData) => {
    // Credentials go DIRECTLY to central auth → { access, refresh, sub }.
    const { data, error } = await signin({ ...formData, platform: platform.admin });
    if (data) {
      const { access, refresh } = data?.data ?? {};
      setTokenLocalStorage(access);
      if (refresh) setRefreshTokenLocalStorage(refresh);
      // Auth's login response has no profile — fetch the admin from the backend.
      try {
        const profile = await fetchProfile().unwrap();
        dispatch(setAuthUser(profile?.data));
      } catch {
        /* profile will be re-fetched by the dashboard */
      }
      successMsg(data.message);
      navigate(link.dashboard);
    } else {
      errorMsg(error?.data?.message || error?.data?.error?.message || 'Login failed');
    }
  };

  return (
    <div className="login-page">
      <h1 className="heading mb-4">Welcome to Admin</h1>
      <span className="sub-text text-grey ">Login to your account</span>

      <form className="mt-7" onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-4">
          <ThemeInput
            name="email"
            control={control}
            errors={errors}
            label="Email"
            placeholder="Input your email"
            type="text"
            maxLength={validation.emailMax}
            labelClassName="font-medium"
          />
        </div>

        <div className="mb-4">
          <ThemeInput
            name="password"
            control={control}
            errors={errors}
            label="Password"
            placeholder="Input your password"
            type="password"
            minLength={validation.passwordMin}
            maxLength={validation.passwordMax}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            labelClassName="font-medium"
          />
        </div>

        <ThemeButton type="submit" className="w-full mt-2" text="Sign In" loading={isLoading} />
      </form>
    </div>
  );
};

export default LoginPage;
